var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#60E4DD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.706 11.2635C5.87475 11.0076 6.0345 10.7679 6.18525 10.5435H4.46175C4.44788 10.5435 4.43457 10.538 4.42476 10.5282C4.41495 10.5184 4.40944 10.5051 4.40944 10.4912V10.1334C4.40944 10.1047 4.43306 10.0811 4.46175 10.0811H6.49913C7.58869 8.48981 8.13319 7.8345 8.13319 7.76756C8.13319 7.66462 8.11069 7.61344 7.73944 7.61344C7.00594 7.61344 5.79938 7.08975 5.79938 5.65988C5.79938 4.88194 7.05769 3.9375 7.79231 3.9375C8.13319 3.9375 8.1855 4.08206 8.02856 4.09163C7.60894 4.1175 6.69094 4.95563 6.69094 5.76225C6.69094 6.30225 7.17019 7.22756 8.23781 7.22756C9.49894 7.22756 10.5761 5.22281 13.1946 5.22281C14.7679 5.22281 15.1875 6.45356 15.1875 6.79106C15.1875 7.12856 14.6964 7.30519 14.0338 7.30519C13.3712 7.30519 13.3464 6.12225 12.0144 6.12225C9.92306 6.12225 8.14219 8.38688 7.28663 10.0811H8.76263C8.79187 10.0811 8.81494 10.1047 8.81494 10.1334V10.4912C8.81501 10.4981 8.81371 10.505 8.81112 10.5114C8.80852 10.5178 8.80468 10.5236 8.79982 10.5285C8.79495 10.5335 8.78916 10.5374 8.78277 10.54C8.77639 10.5427 8.76954 10.5441 8.76263 10.5441H7.0695C6.9525 10.8141 6.86531 11.0587 6.81075 11.2641H8.29012C8.31938 11.2641 8.343 11.2866 8.343 11.3158V11.6741C8.343 11.688 8.33749 11.7013 8.32768 11.7111C8.31787 11.7209 8.30456 11.7264 8.29069 11.7264H6.74437C6.77194 12.3823 7.32206 12.9735 8.39587 13.5H4.27837C4.64741 12.905 5.02243 12.3138 5.40337 11.7264H3.99037C3.98346 11.7265 3.97659 11.7252 3.97018 11.7226C3.96377 11.72 3.95794 11.7162 3.95302 11.7113C3.9481 11.7065 3.9442 11.7007 3.94154 11.6943C3.93887 11.6879 3.9375 11.681 3.9375 11.6741V11.3158C3.9375 11.2871 3.96112 11.2635 3.98981 11.2635H5.706Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRic);
export default __webpack_public_path__ + "static/media/ric.4b7e132d3867324a94fe03b52cd652fb.svg";
export { ForwardRef as ReactComponent };